// removed by extract-text-webpack-plugin
module.exports = {"name":"BrandColorValueCmyk_name_3FkDu","value":"BrandColorValueCmyk_value_3nSsm"};